import React, { useState } from 'react';
import './ContactUs.css';

function ContactUs() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    message: '',
    preferredLot: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Here you would typically send the data to a backend or an email service (like Resend/SendGrid)
    alert('Thank you for reaching out! We will get back to you shortly.');
    setFormData({ name: '', email: '', phone: '', service: '', message: '', preferredLot: '' });
  };

  return (
    <div className="contact-page">
      <div className="contact-hero">
        <h1 className="contact-title">Get in <span className="highlight-text">Touch</span></h1>
        <p className="contact-subtitle">Whether you have a question about our Virtual Tours, custom software, or just want to say hi, we'd love to hear from you.</p>
      </div>

      <div className="contact-container">
        <div className="contact-info">
          <h2>Contact Information</h2>
          <p>Reach out directly or fill out the form, and our team will get back to you within 24 hours.</p>
          
          <div className="info-item">
            <span className="info-icon">📍</span>
            <div>
              <h3>Location</h3>
              <p>Atlanta, GA</p>
            </div>
          </div>
          
          <div className="info-item">
            <span className="info-icon">📞</span>
            <div>
              <h3>Phone</h3>
              <p><a href="tel:404-914-6066">404-914-6066</a></p>
            </div>
          </div>

          <div className="info-item">
            <span className="info-icon">✉️</span>
            <div>
              <h3>Email</h3>
              <p><a href="mailto:contact@thrillarts.com">contact@thrillarts.com</a></p>
            </div>
          </div>
        </div>

        <div className="contact-form-wrapper">
          <form className="contact-form" onSubmit={handleSubmit}>
            <h2>Send us a Message</h2>
            
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="name">Your Name</label>
                <input 
                  type="text" 
                  id="name" 
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="John Doe" 
                  required 
                />
              </div>
              <div className="form-group">
                <label htmlFor="email">Email Address</label>
                <input 
                  type="email" 
                  id="email" 
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="john@example.com" 
                  required 
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="phone">Phone Number (Optional)</label>
                <input 
                  type="tel" 
                  id="phone" 
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="(555) 555-5555" 
                />
              </div>
              <div className="form-group">
                <label htmlFor="service">Service of Interest</label>
                <select 
                  id="service" 
                  name="service"
                  value={formData.service}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select a service...</option>
                  <option value="virtual_tours">360° Virtual Tours</option>
                  <option value="app_dev">Custom App/Web Development</option>
                  <option value="metaverse">Metaverse Land/Rooms</option>
                  <option value="music">Music Production</option>
                  <option value="art">Digital Art & Design</option>
                  <option value="other">Other Inquiry</option>
                </select>
              </div>
            </div>

            {formData.service === 'metaverse' && (
              <div className="metaverse-contact-addon">
                <div className="form-group full-width">
                  <label>Available Metaverse Lots</label>
                  <div className="contact-map-container">
                    <img src="/images/metaverse-map.png" alt="Available Metaverse Lots" className="contact-metaverse-map" />
                  </div>
                </div>
                <div className="form-group full-width">
                  <label htmlFor="preferredLot">Preferred Lot Number (Optional)</label>
                  <input 
                    type="text" 
                    id="preferredLot" 
                    name="preferredLot"
                    value={formData.preferredLot}
                    onChange={handleChange}
                    placeholder="e.g. Lot 104, Lot 125" 
                  />
                </div>
              </div>
            )}

            <div className="form-group full-width">
              <label htmlFor="message">Your Message</label>
              <textarea 
                id="message" 
                name="message"
                value={formData.message}
                onChange={handleChange}
                rows="6" 
                placeholder="How can we help you?" 
                required
              ></textarea>
            </div>

            <button type="submit" className="contact-submit-btn">Send Message</button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default ContactUs;
